<template>
<div class="form-label-group">
    <label class="px-0">
    <span class="text-danger" v-if="required">*</span>
    Select Location
    </label>

    <Select2 v-model="location_id"
        :options="locations_data | selectify('id','name')"
        :name="name"
        :settings="{ placeholder: 'Select Locations'}" :required="required"
        @change="$emit('location-changed', location_id)"
        />
</div>
</template>

<script>
import Select2 from 'v-select2-component';

    export default {
        components: {Select2},

        created(){
            let vm=this;
            axios.get(`/${vm.user_type}/locations/get-all`)
                .then(function (response) {
                    vm.locations_data=response.data;
                })
                .catch(function (errors) {
                    // console.log(errors);
                    vm.showErrorMessage('Someting Went wrong.');
                });
        },
        props:{required:{default:false},name:{default:'Location'},location_id_prop:{default:''}},
        data(){
            return {
                locations_data:[],
                location_id:this.location_id_prop,
            }
        },
        methods:{
            clearSelection() {
           this.location_id = null; // Set the value to null to clear the selection
          },
        }
    }
</script>
